import classNames from "classnames";
import { get } from "lodash";
import checkSmall from "../../Assets/icons/check_small.svg";
import checkSmallAccent from "../../Assets/icons/check_small_white.svg";
import openInNew from "../../Assets/icons/open_in_new.svg";
import Button from "../../Components/Button";
import Cost from "../../Components/Cost";

const ProductCard = ({
  name,
  price,
  action,
  info,
  links,
  linkLabels,
  recommendation,
}) => {
  const isRecommended = recommendation?.value;
  const checkIcon = isRecommended ? checkSmallAccent : checkSmall;

  const documentLinks = [
    {
      key: "guarantees",
      label: linkLabels?.guaranteesTable,
      onClick: links?.guarantees,
    },
    {
      key: "example",
      label: linkLabels?.reimbursementExamples,
      onClick: links?.example,
    },
    {
      key: "regulation",
      label: linkLabels?.regulation,
      onClick: links?.regulation,
    },
    {
      key: "statuses",
      label: linkLabels?.statuses,
      onClick: links?.statuses,
    },
    {
      key: "ipid",
      label: linkLabels?.ipid,
      onClick: links?.ipid,
    },
  ].filter((link) => link.label && link.onClick);

  return (
    <div className="product--item">
      <div
        className={classNames({
          "recommended--product": isRecommended,
        })}
      >
        <div className="product--item--wrapper">
          {isRecommended && (
            <span className="product--item--tag">
              {recommendation?.label}
            </span>
          )}
          <div className="product--item--body">
            <div className="product--item--header">
              <span className="product--item--header--name">{name}</span>
              <Cost
                cost={get(price, "cost", 0)}
                currency={get(price, "currency", "EUR")}
                className={classNames({
                  "acoris-cost--on-primary": isRecommended,
                })}
              />
            </div>
            <div className="product--item--middle">
              <div className="product--item--action">
                <Button
                  type={isRecommended ? "default" : "primary"}
                  onClick={action?.onClick}
                  loading={action?.loading}
                  disabled={action?.disabled}
                >
                  {action?.label}
                </Button>
              </div>
              <div className="product--item--info">
                <span className="product--item--info--title">
                  {info?.title}
                </span>
                <div className="product--item--info--list">
                  {get(info, "items", []).map((item, i) => (
                    <div key={i} className="item">
                      <img
                        src={checkIcon}
                        alt=""
                        className="product--item--check"
                        width={20}
                        height={20}
                      />
                      <span className="content">
                        {item.mainInfo || item.coverage}
                        {(item.value || item.limit) && (
                          <> {item.value || item.limit}</>
                        )}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="product--item--links">
            {documentLinks.map((link) => (
              <div
                key={link.key}
                role="button"
                tabIndex={0}
                className="product--item--doc-link"
                onClick={link.onClick}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    link.onClick();
                  }
                }}
              >
                <span className="product--item--doc-link-label">
                  {link.label}
                </span>
                <span className="product--item--doc-link-icon" aria-hidden>
                  <img src={openInNew} alt="" width={16} height={16} />
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
